<!--------------------------------------------------------------headers--------------------------------------------------------------------------->
<div class="container">
  <div class="row px-3" style="min-height: 500px">
    <div class="col-12 col-md-6 position-relative">


      <div class=" title text-center">


        <div class="d-flex my-5 justify-content-around" [dir]="apiService.currentDirection">


          <div class="row col-12 pt-3 justify-content-center">
            <div class="row col-12 justify-content-center" style="margin: 10px;">
              <img src="../../../assets/img/Alobodo.png" class="alobodoLogo" />
              <h1 style="font-size: 56px; font-family: 'lalehzar' !important;">{{'Alobodo'|translate}}</h1>
            </div>
            <h2 class="bold">{{'AUniversalPlatformForMobileServices'|translate}}</h2>
          </div>
          <!-- <div class="row col-12">
            <h2 class="bold">{{'AUniversalPlatformForMobileServices'|translate}}</h2>
          </div> -->

        </div>

        <my-search></my-search>
        <!--        <form class="d-flex position-relative"-->
        <!--              [ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}">-->

        <!--          <input class="form-control" placeholder="" [(ngModel)]="searchText" (keyup)="search()"-->
        <!--                 [ngModelOptions]="{standalone: true}" #searchInput [placeholder]="'WhatServiceDoYouNeed'|translate"-->
        <!--                 [ngClass]="this.apiService.currentDirection ==='rtl'? 'input-rtl': 'input-ltr'"/>-->
        <!--          <div class="form-control"-->
        <!--               style="    transition: 1s;max-height: 230px;height: min-content; overflow-y: auto; display: none; position: absolute;top:54px; text-align: justify;padding: 0"-->
        <!--               #searchBox id="searchBox">-->
        <!--            <ul id="resultResult">-->

        <!--            </ul>-->

        <!--          </div>-->
        <!--          &lt;!&ndash;          <datalist id="searchResult">&ndash;&gt;-->
        <!--          &lt;!&ndash;            <option *ngFor="let item of searchResult" [value]="item.categoryId">{{item.name}}</option>&ndash;&gt;-->

        <!--          &lt;!&ndash;          </datalist>&ndash;&gt;-->
        <!--          <button class="btn btn-primary custom-btn" (click)="navigateToFirstItem()"-->
        <!--                  [ngClass]="this.apiService.currentDirection ==='rtl'? 'searchBtn-rtl': 'searchBtn-ltr'"-->
        <!--                  type="submit">{{'Search'|translate}}-->
        <!--          </button>-->

        <!--        </form>-->

        <!-- <div class="d-flex mt-5 justify-content-center" [dir]="apiService.currentDirection">
          <img src="../../../assets/img/asnaf.png" class="mt-3" width="50px" height="50px"/>
          <h4 class="my-4 mx-3 bold">{{'withCooperationOfShirazChamberOfGuilds'|translate}}</h4>

        </div> -->
      </div>
    </div>
    <div class="col-12 col-md-6 banner">
      <div class="banner">
        <img id="bannerImage" src="" alt="" width="100%" />
      </div>

    </div>

  </div>
</div>
<div class="border-bottom">

</div>

<!---------------------------------------------------- popular categories ------------------------------------------------------------>
<div class="row py-5 graySection" [dir]="apiService.currentDirection">
  <div class="container">
    <h2 [ngStyle]="{'text-align':this.apiService.currentDirection === 'rtl'? 'right':'left'}" style="font-weight: bold"> 
      {{'PopularCategory' | translate}} </h2>
    <div class="row popCatMobile">
      
      <ngb-carousel>
        <ng-template ngbSlide *ngFor="let popCat of popularCategories">
          <div class="wrapper">
            <a [href]="'https://web.alobodo.com/services?id=' + popCat.categoryId + '&title=' + popCat.categoryName +  '&isLeaf='+ popCat.isLeaf" target="_blank">
              <img class="popCatImg" *ngIf="popCat.imageBase64" [src]="popCat.imageBase64" 
              [alt]="popCat.imageAlt" width="300px" height="180px">
              <img class="popCatImg" *ngIf="!popCat.imageBase64" src="../../../assets/img/comingSoon.jpg" 
              [alt]="popCat.imageAlt" width="300px" height="180px">
            </a>
          </div>
          <div class="carousel-caption">
            <!-- <h3>{{ image.title }}</h3>
            <p>{{ image.description }}</p> -->
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
    <div class="row popCatDesktop">
      <div class="" *ngFor="let popCat of popularCategories | slice:0:3">
        <a [href]="'https://web.alobodo.com/services?id=' + popCat.categoryId + '&title=' + popCat.categoryName +  '&isLeaf='+ popCat.isLeaf" target="_blank">
          <img class="popCatImg" *ngIf="popCat.imageBase64" [src]="popCat.imageBase64" [alt]="popCat.imageAlt" width="370px" height="200px">
          <img class="popCatImg" *ngIf="!popCat.imageBase64" src="../../../assets/img/comingSoon.jpg" 
              [alt]="popCat.imageAlt" width="370px" height="200px">
        </a>
      </div>
    </div>
  </div>
</div>

<!--------------------------------------------------------------Downloads--------------------------------------------------------------------------->
<div class="row py-5" [dir]="apiService.currentDirection" id="download">
  <div class="container ">
    <div class="row px-3">
      <div class="col-12 col-md-6">
        <img [ngStyle]="{'display':this.apiService.currentDirection === 'rtl'? 'block':'none'}"
          src="../../../assets/img/carousel/FA-2+.png" alt="Random first slide" width="100%"
          alt="در تصویر از موکاپ‌های اپلیکیشن استفاده شده است تا کاربران بتوانند با نگاهی به تصویر متوجه شوند که می‌توانند تکنسین مورد نظر خود را انتخاب کنند، رزومه آن را ببینند و بتوانند با آن ارتباط برقرار کنند و آدرس خود را از طریق نقشه منتشر کنند. ">
        <img [ngStyle]="{'display':this.apiService.currentDirection === 'ltr'? 'block':'none'}"
          src="../../../assets/img/carousel/EN 2+.jpg" alt="Random first slide" width="100%"
          alt="In the image, mockups of the application have been used so that users can understand at a glance that they can choose their desired technician, see their resume, contact them, and publish their address via the map.">
      </div>
      <div class="col-12 col-md-6">
        <h2 class="my-1 text-center mt-4 " style="font-weight: bold">{{'DownloadAlobodoApplication'|translate}}</h2>
        <p class="text-justify py-5" style="line-height: 1.4em; font-size: 20px;">{{'AlobodoIsAnOnline.'|translate}}</p>
        <div class="d-flex justify-content-center">
          <a href="https://play.google.com/store/apps/details?id=medis.holding.alobodoapp" target="_blank"
            class="btn border m-2  downloadLink">
            <div class="d-flex justify-content-around">
              <div class="mini pt-1">
                <img src="../../../assets/img/downloadLink/google-play.png" class="fade-in mini">
              </div>
              <div>
                <p class="miniText">{{'GetItOn'|translate}}</p>
                <p class="miniText bold"> {{'GooglePlay' | translate}} </p>
              </div>
            </div>
          </a>

          <a (click)="open(modal)" class="btn border m-2  downloadLink">
            <div class="d-flex justify-content-around">
              <div class="mini pt-1">
                <img src="../../../assets/img/downloadLink/appstore_logo.png" class="fade-in mini">
              </div>
              <div>
                <p class="miniText">{{'GetItOn'|translate}}</p>
                <p class="miniText bold">{{'AppleStore'|translate}}</p>
              </div>
            </div>

          </a>
        </div>
        <div class="d-flex justify-content-center">
          <a href="https://web.alobodo.com/" class="btn border m-2  downloadLink" target="_blank">
            <div class="d-flex justify-content-around">
              <div class="mini pt-1">
                <img src="../../../assets/img/downloadLink/globe.png" class="fade-in mini">
              </div>
              <div>
                <p class="miniText">{{'LaunchAs'|translate}}</p>
                <p class="miniText bold"> {{'WebApp'|translate}}</p>
              </div>
            </div>

          </a>
          <!--          <a href="https://www.alobodo.com/download/alobodo_v2.2.2.apk"  download class="btn border m-2  downloadLink" target="_blank">-->
          <a [href]=this.internalService.androidLink download class="btn border m-2  downloadLink" target="_blank">
            <div class="d-flex justify-content-around">
              <div class="mini pt-1">
                <img src="../../../assets/img/downloadLink/android.png" class="fade-in mini">
              </div>

              <div>
                <p class="miniText">{{'DirectDownload'|translate}}</p>
                <p class="miniText bold">{{'AndroidVersion'|translate}}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<!--------------------------------------------------------------carousel-------------------------------------------------------------------------------------------->


<!--<div class="whiteSection">-->
<!--  <div class="container mt-5 pt-5">-->
<!--    <ngb-carousel #myCarousel *ngIf="images" (click)="onSlideClicked(myCarousel)">-->
<!--      <ng-template ngbSlide>-->
<!--        <div class="picsum-img-wrapper">-->
<!--          &lt;!&ndash;          <img [src]="images[0]" alt="Random first slide">&ndash;&gt;-->
<!--          <div class="container">-->
<!--            <div class="row">-->
<!--              <div class="col-12 col-md-5" style="background-color: #fff">-->
<!--                <div class="container">-->

<!--                  <h5 class="my-5"> الوبدو</h5>-->

<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-6">-->
<!--                <img src="../../../assets/img/carousel/15.jpg" alt="Random first slide" width="100%">-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->


<!--        </div>-->
<!--        &lt;!&ndash;        <div class="carousel-caption">&ndash;&gt;-->
<!--        &lt;!&ndash;          <div class="container">&ndash;&gt;-->


<!--      </ng-template>-->
<!--      <ng-template ngbSlide>-->
<!--        <div class="picsum-img-wrapper">-->
<!--          &lt;!&ndash;          <img [src]="images[0]" alt="Random first slide">&ndash;&gt;-->
<!--          <div class="container">-->
<!--            <div class="row">-->
<!--              <div class="col-12 col-md-6" style="background-color: #fff">-->
<!--                <div class="container">-->

<!--                  <h5 class="my-5">When you need to hire someone – a landscaper, a DJ, anyone – Thumbtack finds them for-->
<!--                    you for free.</h5>-->
<!--                  <a href="https://play.google.com/store/apps/details?id=medis.holding.alobodoapp"-->
<!--                     class="btn border m-2" target="_blank">-->
<!--                    <img src="../../../assets/img/AppStore1.png" class="fade-in" width="140" height="40">-->
<!--                  </a>-->

<!--                  <a href="https://sibapp.com/applications/Alobodo" class="btn border m-2" target="_blank">-->
<!--                    <img src="../../../assets/img/sibApp2-fa.png" class="fade-in" width="140" height="40">-->
<!--                  </a>-->

<!--                  <a href="https://web.alobodo.com/#/index" class="btn border m-2" target="_blank">-->
<!--                    <img src="../../../assets/img/pwa-en.png" class="fade-in" width="140" height="40">-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-6">-->
<!--                <img [src]="images[0]" alt="Random first slide" width="95%">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--      <ng-template ngbSlide>-->
<!--        <div class="picsum-img-wrapper">-->
<!--          <img [src]="images[1]" alt="Random second slide">-->
<!--        </div>-->
<!--        <div class="carousel-caption">-->
<!--          <h3>No mouse events...</h3>-->
<!--          <p>This carousel doesn't pause or resume on mouse events</p>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--      <ng-template ngbSlide>-->
<!--        <div class="picsum-img-wrapper">-->
<!--          <img [src]="images[2]" alt="Random third slide">-->
<!--        </div>-->

<!--        <div class="carousel-caption">-->
<!--          <h3>No keyboard...</h3>-->
<!--          <p>This carousel uses customized default values.</p>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--      <ng-template ngbSlide>-->
<!--        <div class="picsum-img-wrapper">-->
<!--          <img [src]="images[3]" alt="Random fourth slide">-->
<!--        </div>-->
<!--        <div class="carousel-caption">-->
<!--          <h3>And no wrap after last slide.</h3>-->
<!--          <p>This carousel uses customized default values.</p>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </ngb-carousel>-->

<!--  </div>-->
<!--</div>-->


<!-------------------------------------------------mat-tab categories--------------------------------------------------------------------------->
<div class="row py-5 graySection" [dir]="this.apiService.currentDirection">
  <div class="container position-relative">
    <div class="loader" *ngIf="loader"></div>
    <mat-tab-group mat-align-tabs="start" [(selectedIndex)]="tabIndex" *ngIf="!loader"
      (selectedTabChange)="tabChange($event.index, $event)" #mat>


      <mat-tab *ngFor="let item of categories;" label="{{item.title}}">
        <div class="row col-12 mt-3 mx-auto categoryBanner pointer"
          [style.background-image]="'url(' + item.bannerImage + ')'"
          (click)="internalService.setIsLeaf();this.router.navigate(['/service-description/'+item.id])">
          <!-- <img [src]="item.iconImage"
               [ngStyle]="{'right':this.apiService.currentDirection === 'rtl' ? '52px': null,'left':this.apiService.currentDirection === 'ltr' ? '52px': null}"/> -->
          <div class=" p-4 position-relative">
            <div *ngIf="item.description"
              [ngClass]="apiService.currentDirection==='rtl'? 'descriptionRtl' : 'descriptionLtr'">
              <p class="pb-1" [innerHTML]="(item.description.split('</p>')[0])"></p>
              <a class="detailBtn" (click)="internalService.setIsLeaf()"
                [routerLink]="['/service-description/'+item.id]">{{'Details'|translate}}</a>
            </div>
          </div>

        </div>
        <div class="row mt-3 mx-auto subcategory">
          <div class="col-md-4 col-6" *ngFor="let subCat of item.subCategoies">

            <div class="card" style="cursor: pointer" (click)="internalService.setIsLeafTrue()"
              [routerLink]="['/service-description/'+subCat.id]">

              <img [src]="subCat.base64" *ngIf="subCat.base64" [title]="subCat.title" style="width:100%;">
              <div class=" loader mini-loader" *ngIf="!subCat.base64"></div>
              <div class="container py-3">
                <p class="cardTitle"
                  [ngStyle]="{'text-align':this.apiService.currentDirection === 'rtl'? 'right':'left'}">{{subCat.title}}
                </p>
              </div>
            </div>
          </div>

        </div>
        <!--        <div class="text-center px-4">-->
        <!--          <my-slider *ngIf="item.subCategoies" [getListData]="item.subCategoies" [totalCards]="item.subCategoies.length"-->
        <!--                     [size]="300"></my-slider>-->
        <!--        </div>-->


      </mat-tab>
    </mat-tab-group>
  </div>

</div>

<!---------------------------------------------------Features--------------------------------------------------------------------------->
<div class="whiteSection" id="features" [dir]="apiService.currentDirection">
  <!-- <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="col-6">
          <p>sdg</p>
        </div>
        <div class="col-6">
          <p>rdfegrds</p>
        </div>
      </div>
    </div>
  </div> -->
  <div class="container ">
    <div class="row  px-3">
      <div class="col-12 col-md-6 pt-3 text-justify">
        <h2 class="my-1 text-center my-4 " style="font-weight: bold"> {{'Features'|translate}}</h2>
        <div class="feature">
          <img src="../../../assets/img/features/1+.png" />
          <div>
            <h5 class="bold">{{'RatingAndFeedbacks'|translate}}</h5>
            <p class="text-justify">{{'EachSpecialistWillBeEvaluated.'|translate}}</p>
          </div>

        </div>
        <div class="feature">
          <img src="../../../assets/img/features/2+(1).png" />
          <div>
            <h5 class="bold">{{'VarietyOfServices'|translate}}</h5>
            <p class="text-justify">{{'OneOfTheFeaturesOf...'|translate}}
            </p>
          </div>

        </div>
        <div class="feature">
          <img src="../../../assets/img/features/3+.png" />
          <div>
            <h5 class="bold">{{'ApprovedPrices'|translate}} </h5>
            <p class="text-justify">{{'InAlobodoThePrice...'|translate}} </p>
          </div>

        </div>

        <div class="feature">
          <img src="../../../assets/img/features/4+.png" style="height: 30px; width: 30px;" />
          <div>
            <h5 class="bold"> {{'ProvideValidCertificatesWorkSamples'|translate}} </h5>
            <p class="text-justify">{{'EverySpecialistTechnicianIn...'|translate}} </p>
          </div>

        </div>
        <div class="feature">
          <img src="../../../assets/img/features/5+.png" style="height: 40px; width: 40px; margin:-4px 4px;" />
          <div>
            <h5 class="bold">{{'EaseOfUse'|translate}}</h5>
            <p class="text-justify">{{'AllOfAlbodoEfforts...'|translate}}</p>
          </div>

        </div>

      </div>
      <div class="col-12 col-md-6 pt-3 text-justify" style="padding: 0 !important;">
        <img src="../../../assets/img/carousel/d.png" class="questionImage" height="100%" width="100%"
          style="float: left;" *ngIf="apiService.currentDirection==='rtl'"
          alt="در تصویر از موکاپ‌های اپلیکیشن استفاده شده است تا کاربران بتوانند با نگاهی به دسته‌بندی متوجه شوند می‌توانند در چه زمینه‌هایی خدمات دریافت کنند و پیام‌هایی که دریافت کرده‌اند را مشاهده کنند و در نهایت بتوانند حساب خود را به تکنسین ارتقا دهند. " />
        <img src="../../../assets/img/carousel/s.png" class="questionImage" height="100%" width="100%"
          style="float: right;" *ngIf="apiService.currentDirection!=='rtl'"
          alt="In the image, mockups of the application have been used so that users can understand at a glance in which fields they can receive services through categorization, view the messages they have received, and ultimately upgrade their account to a technician." />


      </div>
      <!-- <div class="row justify-content-center">
        <img src="../../../assets/img/carousel/FA 001.png" class="questionImage" width="65%"
             [ngStyle]="{'display':apiService.currentDirection==='rtl'? 'block': 'none'}"/>
        <img src="../../../assets/img/carousel/EN 001.png" class="questionImage" width="65%"
             [ngStyle]="{'display':apiService.currentDirection==='ltr'? 'block': 'none'}"/>     
      </div> -->
    </div>

  </div>
</div>


<!-----------------------------------------------------------------Questions-------------------------------------------------------------------------->
<div class="row graySection" [dir]="apiService.currentDirection">
  <div class="container mt-5">
    <div class="row  px-3">
      <div class="col-12 col-md-6">
        <img src="../../../assets/img/2+.png" style="width: 600px; margin-top: -80px;" class="questionImage" alt="{{'AltForWhyTrust'|translate}}"
          [ngStyle]="{'float':apiService.currentDirection==='rtl'? 'left': 'right'}" />
      </div>

      <div class="col-12 col-md-6 pt-3">
        <h2 class="my-1 text-center my-4 " style="font-weight: bold">{{'WhyTrustAlbodo?'|translate}}</h2>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'AnyTimeSupport'|translate}}
              </mat-panel-title>
              <mat-panel-description class="text-left">

              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row col-12  text-justify">
              {{'AlobodoAlongWithUserDuring...'|translate}}
            </div>
            <!--        <p *ngFor="let item of question.answers">{{item.content}}</p>-->
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'ApprovedSpecialistsGuildChamber'|translate}}
              </mat-panel-title>
              <mat-panel-description class="text-left">
                <!--                    This is a summary of the content-->
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row col-12 text-justify">
              {{'AllSpecialistsTechniciansAreExperienced...'|translate}}
            </div>
            <!--        <p *ngFor="let item of question.answers">{{item.content}}</p>-->
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title [ngStyle]="{'text-align':apiService.currentDirection === 'rtl'? 'right':'left'}">
                {{'ApprovedPricesFarsChamberGuilds'|translate}}
              </mat-panel-title>
              <mat-panel-description class="text-left">
                <!--                    This is a summary of the content-->
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row col-12 text-justify">
              {{'InAlobodoTheCostOfEachService...'|translate}}
            </div>
            <!--        <p *ngFor="let item of question.answers">{{item.content}}</p>-->
          </mat-expansion-panel>
        </mat-accordion>
      </div>      

    </div>

  </div>
</div>

<!--<my-card></my-card>-->
<!-------------------------------------------------about------------------------------------------------------------------------------------------------------------>
<div class="row py-5 whiteSection" id="about">
  <div class="container my-5" style="padding: 30px;"
    [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl' ? 'rtl' : 'ltr'}">
    <h2 class="text-center py-3" style="font-weight: bold">{{'WithAlobodoWorkandgetyourWorksDone!'|translate}}</h2>
    <p class="text-justify px-3" style="line-height: 2.5rem">
      {{'AboutAlobodoContent...'|translate}}
    </p>

  </div>
</div>



<!--------------------------------------- modal --------------------------------------->

<ng-template class="modal" let-c="close" let-d="dismiss" #modal let-modal>
  <div class="cookiesContent" id="cookiesPopup">
    <button (click)="d('Cross click')" class="close">✖</button>
    <img src="../../../assets/img/work-time.png" alt="cookies-img" />
    <p> {{'FixedLink' | translate}} </p>
    <button (click)="d('Cross click')" class="accept"> {{'Close' | translate}} </button>
  </div>
</ng-template>